import React from 'react';
import { Modal } from 'antd';

const ImagePreviewModal = ({ open, image, alt, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable
      width={520}
      centered
      maskClosable
      styles={{ body: { textAlign: 'center', padding: 16 } }}
    >
      {image && (
        <img
          src={image}
          alt={alt || 'معاينة الصورة'}
          style={{
            maxWidth: '100%',
            maxHeight: '70vh',
            objectFit: 'contain',
            borderRadius: 8,
            display: 'block',
            margin: '0 auto'
          }}
        />
      )}
    </Modal>
  );
};

export default ImagePreviewModal;
